/**
 * This file was copied from dashboard into clowncar as part of a cleanup effort
 */
import { ActiveAuth } from '@tock/logging';
import { RoleType } from '@tock/coretypes';
import { StoreType } from '@tock/shared/utils/connect';
import { createSelector } from 'reselect';
import { hasRole } from 'utils/roleUtils';
import { shouldDisplayForRole } from 'components/product/RoleRestriction';

const activeAuthSelector = (state: StoreType) => state?.app?.activeAuth;

function computeHasRole(roleTypes: RoleType[]): (activeAuth: ActiveAuth | undefined) => boolean {
  return (activeAuth): boolean => {
    return hasRole(activeAuth, roleTypes);
  };
}

export const hasMinGlobalRoleHospitalitySelector = hasRoleSelectorCreator(
  RoleType.ENG,
  RoleType.HOSPITALITY,
  RoleType.FINANCE
);

/**
 * Exported for testing only, this should not be used directly in a component
 */
export function hasRoleSelectorCreator(...roleTypes: RoleType[]) {
  return createSelector(activeAuthSelector, computeHasRole(roleTypes));
}

export const hasDriverRoleSelector = hasRoleSelectorCreator(RoleType.DRIVER);
export const hasHostRoleSelector = hasRoleSelectorCreator(RoleType.HOST);
export const hasEmployeeRoleSelector = hasRoleSelectorCreator(RoleType.EMPLOYEE);
export const hasAdminRoleSelector = hasRoleSelectorCreator(RoleType.ADMIN);
export const hasAccountOwnerRoleSelector = hasRoleSelectorCreator(RoleType.ACCOUNT_OWNER);
export const hasHospitalityRoleSelector = hasRoleSelectorCreator(RoleType.HOSPITALITY);
export const hasFinanceRoleSelector = hasRoleSelectorCreator(RoleType.FINANCE);
export const hasEngRoleSelector = hasRoleSelectorCreator(RoleType.ENG);

export const allRolesStatesSelector = createSelector(
  hasDriverRoleSelector,
  hasHostRoleSelector,
  hasEmployeeRoleSelector,
  hasAdminRoleSelector,
  hasAccountOwnerRoleSelector,
  hasHospitalityRoleSelector,
  hasFinanceRoleSelector,
  hasEngRoleSelector,
  (
    hasDriverRole,
    hasHostRole,
    hasEmployeeRole,
    hasAdminRole,
    hasAccountOwnerRole,
    hasHospitalityRole,
    hasFinanceRole,
    hasEngRole
  ) => {
    return {
      hasDriverRole,
      hasHostRole,
      hasEmployeeRole,
      hasAdminRole,
      hasAccountOwnerRole,
      hasHospitalityRole,
      hasFinanceRole,
      hasEngRole,
    };
  }
);

export function createHasMinRoleSelector(roleType: RoleType) {
  return createSelector(allRolesStatesSelector, (roleStates) => {
    return shouldDisplayForRole(roleType, roleStates, 'min');
  });
}

export function createHasMaxRoleSelector(roleType: RoleType) {
  return createSelector(allRolesStatesSelector, (roleStates) => {
    return shouldDisplayForRole(roleType, roleStates, 'max');
  });
}

export const hasMinRoleAdminSelector = createHasMinRoleSelector(RoleType.ADMIN);
export const hasMinRoleFinanceSelector = createHasMinRoleSelector(RoleType.FINANCE);
export const hasMinRoleHospitalitySelector = createHasMinRoleSelector(RoleType.HOSPITALITY);
export const hasMinRoleEmployeeSelector = createHasMinRoleSelector(RoleType.EMPLOYEE);
